import * as React from "react";
import logo from "../../asset/icons/logo.svg";
import user1 from "../../asset/user1.jpg";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faCheckCircle,
  faClose,
  faRocket,
} from "@fortawesome/free-solid-svg-icons";
import {
  getNotification,
  selectNotifications,
  updateNotification,
  updateNotificationShow,
} from "../../redux/notificationReducer";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useLayoutEffect } from "react";
import { useState } from "react";
import {
  selectCollectorTooltip,
  selectUser,
  sendInvite,
} from "../../redux/userReducer";
import {
  setQuestionMark,
  selectQuestionMark,
} from "../../redux/notificationReducer";
import { API_URL } from "../../config/constants";
import { faCircleArrowRight } from "@fortawesome/free-solid-svg-icons";
import SearchBar from "material-ui-search-bar";
import ReactTooltip from "react-tooltip";
import { InviteNewCollectorModal } from "../Tools";
import Dialog from "@material-ui/core/Dialog";
import mailIcon from "../../asset/icons/mail.png";
import QuestionMarkIcon from "../../asset/question-mark.png";

export const Navbar = ({
  customSettingComponent,
  searchBar = true,
  searchKeyword = "",
  normalBar = false,
  disableArtwork = false,
}) => {
  const navigate = useNavigate();
  const onLogout = (e) => {
    navigate("/logout");
  };

  const notifications = useSelector(selectNotifications);
  const questionMark = useSelector(selectQuestionMark);

  const [navNotifications, setNavNotifications] = useState([]);
  const [isMore, setIsMore] = useState(false);
  const user = useSelector(selectUser);
  const collectorTooltip = useSelector(selectCollectorTooltip);
  const dispatch = useDispatch();
  const [keyword, setKeyword] = useState(searchKeyword);
  const [menu, setMenu] = useState(false);

  const [isCollector, setIsCollector] = useState(false);

  const submitEmail = (email, type) => {
    dispatch(sendInvite(email, type));
  };

  useEffect(() => {
    if (
      notifications &&
      notifications.notifications &&
      notifications.notifications.length > 0
    ) {
      var nav_notifications = [];
      var is_more = false;
      for (var i = 0; i < notifications.notifications.length; i++) {
        nav_notifications.push(notifications.notifications[i]);
        if (i >= 4) {
          is_more = true;
          break;
        }
      }
      setNavNotifications(nav_notifications);
      setIsMore(is_more);
    }
  }, [notifications]);

  useLayoutEffect(() => {
    // if (user && user._id  && !user.tooltip2 && user.role === 'collector')
    if (
      user &&
      user._id &&
      !user.tooltip2 &&
      user.role === "collector" &&
      collectorTooltip !== 100 &&
      document.getElementById("headlessui-menu-button-:r1:")
    )
      document.getElementById("headlessui-menu-button-:r1:").click();
  }, [collectorTooltip, user]);

  useEffect(() => {
    if (user && user._id) {
      setTimeout(() => {
        dispatch(getNotification(user._id));
      }, 5000);
    }
  }, [user, dispatch]);

  const updateNotificationModal = (notification) => {
    dispatch(updateNotification(notification));
    dispatch(updateNotificationShow(true));
  };

  const onEditProfile = (e) => {
    navigate("/user/edit");
  };

  const onBilling = (e) => {
    navigate("/billing");
  };

  const onSearch = () => {
    if (keyword !== "") {
      navigate(`/search?term=${keyword}`);
    }
  };

  const toggleMenu = () => {
    setMenu(!menu);
  };

  return (
    <div className="flex justify-between w-full navbar">
      <InviteNewCollectorModal
        isOpen={isCollector}
        setIsOpen={setIsCollector}
        type="collector"
        submitEmail={submitEmail}
      />

      <div className="rounded absolute top-[19%] md:right-[2%] right-[2%] cursor-pointer">
        <img
          src={QuestionMarkIcon}
          onClick={() => dispatch(setQuestionMark(!questionMark))}
          alt="questionMark"
        />
      </div>
      {/* {questionMark && <div className='absolute top-[17%] md:right-[9%] md:w-[20%] right-[35%] z-30'>
        <div className="w-full talk-bubble tri-right round borderR right-top">
          <div className="bg-opacity-100 talktext">
            <p>
              ATO improves the art market to benefit artists giving them a financial stake in their future while tracking the usage of their artwork digital.
            </p>
            <p> 
              With our automated search tools and smart contracts we are collecting royalties, authenticating artwork and tracking valuable sales data.
            </p>
          </div>
        </div>
      </div>} */}
      <Dialog
        PaperProps={{
          style: {
            backgroundColor: "black",
            padding: "8px",
            borderRadius: "20px",
          },
        }}
        onClose={() => dispatch(setQuestionMark(!questionMark))}
        maxWidth="lg"
        keepMounted
        aria-labelledby="customized-dialog-title"
        open={questionMark}
      >
        <div className="bg-white rounded-[20px] pb-3 pt-[25px] sm:px-[15%] px-[5%] text-center sm:text-[1.2rem] text-[3vw]">
          <img
            className="absolute sm:w-[35px] w-[5vw] sm:right-[5%] sm:top-[30px]  right-[7vw] top-[7vw]"
            onClick={async () => {
              await dispatch(setQuestionMark(!questionMark));
              navigate("/info");
            }}
            src={mailIcon}
            alt="mailbox"
          />
          <div className="flex justify-center w-full">
            <h1 className="font-bold sm:text-[2.2rem] text-[6vw] sm:leading-[2.2rem] leading-[6vw]">
              ATO PLATFORM
            </h1>
            <p className="sm:text-[1rem] text-[3vw] font-bold">SM</p>
          </div>
          <div>
            <p className="p-0">Artists</p>
            <br />
            <p>
              The ATO Platform supports artists by promoting equitable access
              and financial inclusion throughtout the arts ecosystem.
            </p>
            <br />
            <p>
              ATO Platform protects artists digitally, including tracking
              resales, copyright misuse, and counterfeit monitoring and
              reporting using AI.
            </p>
            <br />
            <p>
              Visual artists deserve to be included in the future gains of the
              assets they create.
            </p>
            <p>
              ATO has a mutually beneficial suite of tools to ensure collectors
              willingly participate and will gladly pay royalities.
            </p>
            <br />
            <p>
              Unlike any other reporting tool, ATO is the only one based on true
              free-market economics proven in the real world. It allows
              collectors to buy and resale freely while benefiting from our
              automated data collection and reporting on their art. ATO is also
              the only one that helps protect the value of the art long-term and
              can track real-time price changes.
            </p>
            <br />
            <p>
              Hit "What's ATO" in the top right to learn more or get started
              below.
            </p>
            <br />
          </div>
          {user && !user._id && (
            <div>
              <button
                onClick={async () => {
                  await dispatch(setQuestionMark(!questionMark));
                  navigate("/login");
                }}
                className="bg-[red] text-white py-[2px] px-[40px] sm:text-[1.5rem] text-[3vw] font-bold"
              >
                JOIN NOW
              </button>
            </div>
          )}
        </div>
      </Dialog>

      <div className="flex flex-col w-full md:w-auto">
        <div className="flex gap-6 items-center">
          <Link to="/search?term=" className="my-auto">
            <img className="w-8 md:w-10 min-w-[3rem]" src={logo} alt="logo" />
            <div
              className="hidden mt-1 mr-auto font-bold text-center text-ato-red md:flex"
              style={{ fontSize: "0.4rem", lineHeight: "0.6rem" }}
            >
              ATO Platform℠
            </div>
          </Link>
          <Link
            to="/search/artists?term="
            className="hidden md:flex md:items-center"
          >
            <div className="text-xl font-bold text-ato-red">Artists</div>
          </Link>
          <Link to="/search?term=" className="hidden md:flex md:items-center">
            <h1 className="text-xl font-bold text-ato-red">Artworks</h1>
          </Link>
          {searchBar && (
            <div className="block w-full md:hidden lg:block lg:w-auto">
              <SearchBar
                value={keyword}
                onChange={(newValue) => setKeyword(newValue)}
                onRequestSearch={() => onSearch()}
                className="hidden w-full md:flex md:w-auto"
              />
            </div>
          )}
        </div>
      </div>
      <div className="flex items-center">
        <div className="flex gap-4 ml-3 md:ml-2 lg:ml-3 xl:ml-4">
          {user && user.role === "artist" && !disableArtwork && (
            <div style={{ position: "relative" }} className="hidden md:flex">
              <button
                className="flex justify-center items-center text-white bg-ato-red hover:bg-red-700 border-2 border-red-600 focus:outline-none focus:border-red-700 font-millerBanner rounded-none text-sm px-3 md:px-5 py-1 md:py-2.5 text-center btn-add-artwork"
                type="button"
                onClick={() => navigate("/artwork/edit/0")}
              >
                Add Artwork
                <span className="ml-2 md:ml-4">
                  <svg
                    viewBox="0 0 31 29"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2.14081 0.185457C1.2526 0.505586 0.845854 0.868498 0.404398 1.73447L0 2.52801L0.000882259 12.275C0.00132342 18.3496 0.057351 22.2232 0.149407 22.5558C0.37587 23.3737 0.900116 24.0497 1.62333 24.4563C2.27919 24.8251 2.27992 24.8251 6.93771 24.8696L11.5962 24.914L11.1745 23.9107L10.7526 22.9073L6.68654 22.8335C2.63153 22.7599 2.61976 22.7588 2.33963 22.4114C2.1164 22.1347 2.05993 21.8318 2.06478 20.9362L2.07081 19.8092L5.63437 15.7979C7.5943 13.5918 9.24792 11.7364 9.30924 11.675C9.37042 11.6136 9.96922 12.1111 10.6399 12.7804L11.8595 13.9975L12.4075 13.1694L12.9556 12.3414L12.4881 11.797C12.2311 11.4977 11.4223 10.636 10.6907 9.88212C9.6282 8.78705 9.32542 8.54968 9.18557 8.70193C9.08925 8.80667 7.63562 10.4525 5.95509 12.3592C4.27471 14.266 2.71064 16.0239 2.47933 16.2658L2.05875 16.7056V9.73106V2.75667L2.41977 2.39464L2.78064 2.03247H14.4848H26.189L26.5498 2.39464L26.9109 2.75667V6.12157V9.48646L27.9483 10.1744L28.9858 10.8624L28.9409 6.55809C28.8964 2.27987 28.8939 2.24977 28.5284 1.59594C28.2933 1.1752 27.9001 0.776442 27.4372 0.489506L26.7135 0.0408826L14.717 0.00872209C4.68058 -0.0181275 2.62579 0.0106399 2.14081 0.185457ZM20.0939 4.24947C18.4376 4.74737 18.1732 7.21237 19.6914 8C20.595 8.46883 21.8788 8.14384 22.4034 7.31357C23.0575 6.27809 22.6547 4.87852 21.559 4.37944C20.8965 4.07761 20.7183 4.06182 20.0939 4.24947ZM19.4111 10.6739C17.799 11.0986 16.4794 11.8792 15.2132 13.1567C13.8622 14.52 13.1162 15.8109 12.7188 17.4726C12.3697 18.9323 12.4671 21.3557 12.9282 22.686C13.7209 24.9723 15.4296 26.9353 17.5269 27.969C21.2671 29.8123 25.329 29.1542 28.2408 26.2331C30.4966 23.97 31.4269 20.9863 30.8173 17.9689C30.0902 14.3684 27.4849 11.5764 24.0093 10.673C22.8969 10.3839 20.5103 10.3843 19.4111 10.6739ZM23.8227 12.7494C25.4987 13.2194 27.231 14.6467 28.1192 16.2893C30.3313 20.3806 28.0239 25.5428 23.4489 26.7383C20.5072 27.5069 17.2749 26.2087 15.5961 23.5842C13.2993 19.9935 14.6919 15.0902 18.5497 13.1843C20.2271 12.3555 21.92 12.216 23.8227 12.7494ZM20.7346 16.6374V18.7028H18.6758H16.6171V19.7355V20.7681H18.6758H20.7346V22.8335V24.8988H21.764H22.7933V22.8335V20.7681H24.8521H26.9109V19.7355V18.7028H24.8521H22.7933V16.6374V14.5721H21.764H20.7346V16.6374Z"
                    />
                  </svg>
                </span>
              </button>
            </div>
          )}
          {user && user.role === "artist" && !disableArtwork && (
            <div style={{ position: "relative" }} className="hidden md:flex">
              <button
                className="flex justify-center items-center text-white bg-ato-red hover:bg-red-700 border-2 border-red-600 focus:outline-none focus:border-red-700 font-millerBanner rounded-none text-sm px-3 md:px-5 py-1 md:py-2.5 text-center btn-billing"
                type="button"
                onClick={() => navigate(`/billing`)}
              >
                Upgrade
                <span className="ml-2 md:ml-4">
                  <FontAwesomeIcon icon={faRocket} />
                </span>
              </button>
            </div>
          )}
          {customSettingComponent}
        </div>
        <button
          className="hidden md:block justify-center mx-1 sm:mx-2 md:mx-3 lg:mx-3 items-center text-white bg-ato-red hover:bg-red-700 border-2 border-red-600 focus:outline-none focus:border-red-700 font-millerBanner rounded-none text-sm px-1 sm:px-3 md:px-5 py-1 md:py-2.5 text-center"
          type="button"
          onClick={() => navigate("/info")}
        >
          What's ATO?
        </button>

        {(!user || !user._id) && normalBar && (
          <button
            className="flex justify-center items-center text-white bg-ato-red hover:bg-red-700 border-2 border-red-600 focus:outline-none focus:border-red-700 font-millerBanner rounded-none text-sm px-3 md:px-5 py-1 md:py-2.5 text-center"
            type="button"
            onClick={() => navigate("/login")}
          >
            Login
          </button>
        )}

        <div className="md:hidden flex items-center w-[48px] h-[48px] justify-content">
          <button
            className="outline-none mobile-menu-button "
            onClick={(e) => toggleMenu()}
          >
            <svg
              className=" w-[48px] h-[48px] text-ato-red hover:text-ato-red "
              x-show="!showMenu"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>

        <div
          className={`${
            menu ? "" : "hidden"
          } mobile-menu flex flex-col fade transition duration-300`}
        >
          <button
            className="mx-2 my-2 ml-auto outline-none mobile-menu-button"
            onClick={(e) => toggleMenu()}
          >
            <svg
              className="w-6 h-6 text-ato-red hover:text-ato-red"
              x-show="!showMenu"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <FontAwesomeIcon icon={faClose} />
            </svg>
          </button>
          <ul className="mx-2 text-ato-red">
            <li>
              <Link
                to="/search/artists?term="
                className="block px-2 py-4 font-semibold text-md font-millerBanner"
              >
                Artists
              </Link>
            </li>
            <li className="border-t-2">
              <Link
                to="/search?term="
                className="block px-2 py-4 font-semibold text-md font-millerBanner"
              >
                Artworks
              </Link>
            </li>
            {user && user.role === "artist" && (
              <li className="border-t-2">
                <Link
                  to="/artwork/edit/0"
                  className="block px-2 py-4 font-semibold text-md font-millerBanner"
                >
                  Add Artwork
                </Link>
              </li>
            )}
            <li className="border-t-2">
              <Link
                to="/info"
                className="block px-2 py-4 font-semibold text-md font-millerBanner"
              >
                What's ATO?
              </Link>
            </li>

            {user && (
              <>
                <li className="border-t-2">
                  <Link
                    to="/user/edit"
                    className="block px-2 py-4 font-semibold text-md font-millerBanner"
                  >
                    Profile
                  </Link>
                </li>
                <li className="border-t-2">
                  <Link
                    to="/dashboard"
                    className="block px-2 py-4 font-semibold text-md font-millerBanner"
                  >
                    Dashboard
                  </Link>
                </li>
                <li className="border-t-2">
                  <button
                    onClick={() => {
                      toggleMenu();
                      setIsCollector(true);
                    }}
                    className="block px-2 py-4 font-semibold text-md font-millerBanner"
                  >
                    Invite Collector
                  </button>
                </li>
              </>
            )}
            <li className="border-t-2">
              <Link
                to="/notifications"
                className="block px-2 py-4 font-semibold text-md font-millerBanner"
              >
                Notifications
              </Link>
            </li>
            <li className="border-t-2">
              <Link
                to="/exhibitions"
                className="block px-2 py-4 font-semibold text-md font-millerBanner"
              >
                Exhibitions
              </Link>
            </li>

            {user && user.role === "artist" && (
              <li className="border-t-2">
                <Link
                  to="/billing"
                  className="block px-2 py-4 font-semibold text-md font-millerBanner"
                >
                  Billing
                </Link>
              </li>
            )}
            {user && user.role === "collector" && (
              <li className="border-t-2">
                <Link
                  to="/kyc"
                  className="block px-2 py-4 font-semibold text-md font-millerBanner"
                >
                  KYC
                </Link>
              </li>
            )}
            {user && (
              <li className="border-t-2">
                <Link
                  to="/logout"
                  className="block px-2 py-4 font-semibold text-md font-millerBanner"
                >
                  Logout
                </Link>
              </li>
            )}
          </ul>
        </div>

        {user && user._id && (
          <>
            <Menu
              as="div"
              className="relative hidden p-1 mx-3 md:block md:mx-2 lg:mx-3 xl:mx-4 text-ato-ash"
            >
              <Menu.Button
                data-tip
                data-for="notificationId"
                className="inline-flex justify-center w-full text-sm text-gray-400 rounded-md hover:text-ato-red"
              >
                <FontAwesomeIcon icon={faBell} className="text-3xl" />
                {notifications && notifications.isNew && (
                  <span className="absolute w-2 h-2 transform translate-x-1/2 bg-red-600 rounded-full md:w-3 md:h-3 left-1/2 md:left-1/3 -top-1 "></span>
                )}
              </Menu.Button>
              <ReactTooltip
                id="notificationId"
                place="top" // top, right, bottom, left
                type="dark" // dark, success, warning, error, info, light
                effect="solid" // float, solid
              >
                <span>Notifications</span>
              </ReactTooltip>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-sm shadow-lg w-80 ring-2 ring-gray-200 focus:outline-none">
                  <div className="px-1 py-1 ">
                    {navNotifications.map((notification) => (
                      <Menu.Item key={notification.notification._id}>
                        <button
                          className={`${
                            notification.notification.status === false
                              ? "text-gray-900 font-semibold"
                              : "text-gray-900"
                          } group  w-full items-center rounded-sm px-2 py-4 text-sm text-center`}
                          style={{ borderBottom: "1px solid #ded" }}
                          onClick={(e) => updateNotificationModal(notification)}
                        >
                          {notification.notification.title}
                        </button>
                      </Menu.Item>
                    ))}
                    {isMore && (
                      <Menu.Item>
                        <button
                          className={`text-gray-900 group  w-full items-center rounded-sm px-2 py-4 text-md text-center font-semibold`}
                          onClick={(e) => navigate("/notifications")}
                        >
                          Show more{" "}
                          <FontAwesomeIcon
                            icon={faCircleArrowRight}
                            className="pl-2"
                          />
                        </button>
                      </Menu.Item>
                    )}
                    {navNotifications.length === 0 && (
                      <Menu.Item>
                        <button
                          className={`text-gray-900 group  w-full items-center rounded-sm px-2 py-2 text-sm text-center font-millerBanner`}
                          onClick={(e) => navigate("/notifications")}
                        >
                          No notifications.
                        </button>
                      </Menu.Item>
                    )}
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>

            <Menu
              as="div"
              className="relative hidden text-left md:inline-block nav-menu min-w-[40px]"
            >
              <Menu.Button className="inline-flex justify-center w-full text-sm text-gray-400 rounded-md hover:text-ato-red">
                <img
                  alt="profile"
                  src={
                    user && user.avatar
                      ? API_URL + "/uploads/" + user.avatar
                      : user1
                  }
                  className="object-cover mx-auto rounded-full h-7 w-7 md:h-10 md:w-10 "
                />
              </Menu.Button>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 w-56 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-sm shadow-lg ring-2 ring-gray-200 focus:outline-none ">
                  <div className="px-1 py-1 ">
                    <Menu.Item>
                      {({ active }) => (
                        <button
                          className={`${
                            active ? "bg-red-500 text-white" : "text-gray-900"
                          } group  w-full items-center rounded-sm px-2 py-2 text-sm text-center font-millerBanner`}
                          onClick={(e) => navigate("/dashboard")}
                        >
                          Dashboard
                        </button>
                      )}
                    </Menu.Item>
                    <Menu.Item as="div" className="nav-menu-editProfile">
                      {({ active }) => (
                        <button
                          className={`${
                            active ? "bg-red-500 text-white" : "text-gray-900"
                          } group  w-full items-center rounded-sm px-2 py-2 text-sm text-center font-millerBanner`}
                          onClick={(e) => onEditProfile(e)}
                        >
                          Edit Profile &nbsp;
                          <i className="fa fa-right-from-backet">&nbsp;</i>
                        </button>
                      )}
                    </Menu.Item>
                    {user && user.role === "artist" && (
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className={`${
                              active ? "bg-red-500 text-white" : "text-gray-900"
                            } group  w-full items-center rounded-sm px-2 py-2 text-sm text-center font-millerBanner`}
                            onClick={() => setIsCollector(true)}
                          >
                            Invite Collector
                          </button>
                        )}
                      </Menu.Item>
                    )}
                    <Menu.Item>
                      {({ active }) => (
                        <button
                          className={`${
                            active ? "bg-red-500 text-white" : "text-gray-900"
                          } group  w-full items-center rounded-sm px-2 py-2 text-sm text-center font-millerBanner`}
                          onClick={(e) => navigate("/exhibitions")}
                        >
                          Exhibitions
                        </button>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <button
                          className={`${
                            active ? "bg-red-500 text-white" : "text-gray-900"
                          } group  w-full items-center rounded-sm px-2 py-2 text-sm text-center font-millerBanner`}
                          onClick={(e) => navigate("/news")}
                        >
                          News
                        </button>
                      )}
                    </Menu.Item>

                    {user && user.role === "artist" && (
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className={`${
                              active ? "bg-red-500 text-white" : "text-gray-900"
                            } group  w-full items-center rounded-sm px-2 py-2 text-sm text-center font-millerBanner`}
                            onClick={(e) => onBilling(e)}
                          >
                            Billing
                          </button>
                        )}
                      </Menu.Item>
                    )}
                    {user && user.role === "collector" && (
                      <Menu.Item as="div" className="nav-menu-kyc">
                        {({ active }) => (
                          <button
                            className={`${
                              active ? "bg-red-500 text-white" : "text-gray-900"
                            } group  w-full items-center rounded-sm px-2 py-2 text-sm text-center font-millerBanner`}
                            onClick={(e) => navigate("/kyc")}
                            disabled={user && user.kyc}
                          >
                            {user && user.kyc ? (
                              <>
                                KYC Verified
                                <FontAwesomeIcon
                                  icon={faCheckCircle}
                                  style={{
                                    color: "#E02829",
                                    marginLeft: "5px",
                                  }}
                                />
                              </>
                            ) : (
                              <>KYC Verify</>
                            )}
                            &nbsp;
                            <i className="fa fa-right-from-backet">&nbsp;</i>
                          </button>
                        )}
                      </Menu.Item>
                    )}
                    <Menu.Item>
                      {({ active }) => (
                        <button
                          className={`${
                            active ? "bg-red-500 text-white" : "text-gray-900"
                          } group  w-full items-center rounded-sm px-2 py-2 text-sm text-center font-millerBanner`}
                          onClick={(e) => onLogout(e)}
                        >
                          Logout &nbsp;
                          <i className="fa fa-right-from-backet">&nbsp;</i>
                        </button>
                      )}
                    </Menu.Item>
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          </>
        )}
      </div>
    </div>
  );
};
